//import { Helmet } from 'react-helmet';
import 'swiper/css'
import 'swiper/css/pagination'

import { GlobalStyle } from 'styles/global'
import { config } from 'config'
import { isCurrentPage } from 'helpers'
import { NavigationContextProvider } from 'context/navigation-context'

import { Home } from 'containers/home'
import { Kyrgyzstan } from 'containers/kyrgyzstan'
import { Kazakhstan } from 'containers/kazakhstan'
import { Tajikistan } from 'containers/tajikistan'
import { Kazakhstan2 } from 'containers/kazakhstan-2'
import { Uzbekistan } from 'containers/uzbekistan'
import { Layout } from 'components/layout'
import { AppContextProvider } from 'context/app-context'

const pages = [
  {
    component: <Home />,
    isHome: true,
  },
  {
    component: <Kyrgyzstan />,
  },
  {
    component: <Kazakhstan />,
  },
  {
    component: <Tajikistan />,
  },
  {
    component: <Kazakhstan2 />,
  },
  {
    component: <Uzbekistan />,
  },
]

const findPageById = () => {
  const index = config.pages.findIndex(isCurrentPage)
  return {
    component: pages[index]?.component ?? <Home />,
    isHome: pages[index]?.isHome,
  }
}

function App() {
  const { component, isHome } = findPageById()

  return (
    <AppContextProvider isHome={isHome ?? false}>
      <NavigationContextProvider>
        <Layout stickyHeader={!isHome}>
          <GlobalStyle />
          {component}
        </Layout>
      </NavigationContextProvider>
    </AppContextProvider>
  )
}

export default App
